@if (loading()) {
  <mat-card-content class="history-loading">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="40"
    ></mat-progress-spinner>
  </mat-card-content>
}

@if (!loading()) {
  <mat-card-content>
    <table
      mat-table
      matSort
      class="mat-elevation-z1"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="amount">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          {{ "CREDITS.TABLE.HEADERS.AMOUNT" | translate }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.amount | currency: element.currency : "symbol-narrow" : "1.0" : "hu" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="fee_label">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          {{ "CREDITS.TABLE.HEADERS.FEE" | translate }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.fee_label }}
        </td>
      </ng-container>
      <ng-container matColumnDef="product_label">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          {{ "CREDITS.TABLE.HEADERS.PRODUCT" | translate }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.product_label }}
        </td>
      </ng-container>
      <tr
        *matHeaderRowDef="displayedColumns"
        mat-header-row
      ></tr>
      <tr
        *matRowDef="let row; columns: displayedColumns"
        mat-row
      ></tr>
    </table>
  </mat-card-content>
}
